import { Component } from '@angular/core';

@Component({
    selector: 'app-svg-clock',
    templateUrl: './svg.clock.component.html',
    styleUrls: ['./svg.clock.component.scss'],
    standalone: false
})
export class SvgClockComponent {
}
